/**
 * Standard debounce
 *
 * @param debouncedFunction {function}
 * @param timeoutMillis {number}
 * @return {(function(...[*]): void)|*}
 */
export default function debounce(debouncedFunction, timeoutMillis = 300) {

    let timeout;

    return (...args) => {

        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {

            debouncedFunction.apply(this, args);
        }, timeoutMillis);
    };
}
